export default __webpack_public_path__ + "static/media/home-main.82d5f0d3.png";